import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '热门排行', href: '/#ranking' },
    { label: '分类浏览', href: '/category/rexue' },
    { label: '关于我们', href: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <div className="flex items-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold font-heading text-primary-500 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-read-line text-primary-500 text-2xl"></i>
            </span>
            <span className={isScrolled ? 'text-foreground-900' : 'text-background-50'}>
              香蕉漫画
            </span>
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.href
                  ? 'bg-primary-500 text-background-50'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className={`relative ${isScrolled ? 'block' : 'hidden'}`}>
            <input
              type="text"
              placeholder="搜索漫画..."
              className="w-48 pl-9 pr-4 py-2 rounded-full text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-all"
            />
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400">
              <i className="ri-search-line text-sm"></i>
            </span>
          </div>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
            isScrolled ? 'text-foreground-900' : 'text-background-50'
          }`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.href
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2.5 rounded-lg text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-all"
              />
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400">
                <i className="ri-search-line text-sm"></i>
              </span>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}